import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Editor } from '@tinymce/tinymce-react';
import { useWindowWidth } from '@react-hook/window-size/throttled';
import { toggleIsDataFetching } from '../../../../store/appReducer';
import { setEditorValue } from '../../../../store/richtextReducer';
import style from './RichTextarea.scss';
import { layoutBreakpoint } from '../../../../utils/helpers/layout-breakpoints';
import { getTinyMCEKey } from '../../../../utils/helpers/tiny-mce-key';

const RichTextarea = ({ height, onChange, onInit, toggleIsDataFetching, setEditorValue }) => {
  const windowWidth = useWindowWidth();
  const [initHeight, setInitHeight] = useState(500);
  const bodyHeight = windowWidth < layoutBreakpoint.md ? 250 : height;

  useEffect(() => {
    setInitHeight(windowWidth < layoutBreakpoint.md ? 250 : 500);
  }, [windowWidth]);

  useEffect(() => {
    toggleIsDataFetching(true);
  }, [toggleIsDataFetching]);

  const handleEditorChange = (content) => {
    onChange(content);
    setEditorValue(content);
  };

  const handleInit = () => {
    if (onInit) onInit(true);
    toggleIsDataFetching(false);
  };

  const initData = {
    height: bodyHeight || initHeight,
    content_css: style,
    menubar: false,
    branding: false,
    browser_spellcheck: true,
    mobile: {
      menubar: true,
      toolbar_drawer: 'floating',
    },
    toolbar: 'undo redo | formatselect | bold italic underline | alignleft aligncenter'
      + ' alignright alignjustify | bullist numlist | removeformat',
    setup: (editor) => {
      editor.on('init', () => {
        handleInit();
      });
    },
  };

  return (
    <Editor
      apiKey={getTinyMCEKey()}
      init={initData}
      onEditorChange={handleEditorChange}
    />
  );
};

const mapStateToProps = (state) => ({
  isDataFetching: state.app.isDataFetching,
  editor: state.richtext,
});

export default connect(mapStateToProps, {
  toggleIsDataFetching,
  setEditorValue,
})(RichTextarea);
